import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { DevTool } from "react-hook-form-devtools";
import Image from 'react-bootstrap/Image';
import * as yup from 'yup';
import { useSelector } from 'react-redux';
import analytics from 'util/analytics';
import { useAuth } from 'util/auth'
import {Helmet} from 'react-helmet'
import StarRatings from 'react-star-ratings';
import { apiRequest } from 'util/api/util';
import ShareButton from 'components/ShareButton'

function WriteReview(props) {

    const auth = useAuth()

    const [isLoading, setIsLoading] = useState(false)
    const [writtenReview, setWrittenReview] = useState(null)
    
    const selectedInstructor = useSelector(state => state.widget.instructor);
    
    const viewModel = {
        partnerName: selectedInstructor?.instructorProfile?.pageName ?? selectedInstructor.firstName,
        shareLink: `https://sutrapro.com/${selectedInstructor.widgetName}`,
        twoMinutes: selectedInstructor.studioMode ? "1 minute, we promise!" : "1 minute, I promise!",
        respectful:selectedInstructor.studioMode ? "Please be respectful, we use your feedback to improve your experiences" : "Please be respectful, I use your feedback to improve your experiences",
    }
    const imageUrl = useSelector(state => state.widget.instructor.instructorProfile?.partnerImageUrl ?? state.widget.instructor.profileImageUrl);
    useEffect(() => {
        analytics.page({
            title: 'Write Review'
        })
        // analytics.track("Pre Purchase Viewed", {...selectedOffering})
    }, [])

    useEffect(() => {
        // if (true) {
        //     return
        // }

        if (!auth.userData || !selectedInstructor.id) {
            return
        }

        apiRequest("reviews/getUserReview", "POST", {
            partnerId: selectedInstructor.id
        }).then(review => {
            if (review.ratingOverall) {
                setWrittenReview(review)
            }
            
        })

    }, [auth.userData, selectedInstructor])


    useEffect(() => {
        if (!selectedInstructor.id) {
            return
        }
        setIsLoading(true)
        setIsLoading(false)
    }, [auth, selectedInstructor.id])

    function handleSuccessfulReview(data) {

        analytics.track('Purchase', {
            pixelId: selectedInstructor?.instructorProfile?.facebookPixelId,
            value: data.payment,
            name: data.name,
            offeringId: data.id,
            currency: 'USD',
            location: 'GiftCardCheckout',
            type: data.type, // pack, dropin, subscription
            offering: data.name
        })
    }


    let height;
    const sendPostMessage = () => {
        let conatinerId = "fullWidthWidget"
        if (document.getElementById(conatinerId)) {
            if (height !== document.getElementById(conatinerId).offsetHeight) {
                height = document.getElementById(conatinerId).offsetHeight;
                window.parent.postMessage({
                  frameHeight: height
                }, '*');
                // console.log(height);
              }
        }
        
    }
    useEffect(() => {
        sendPostMessage()
    })

    const [ratingOverall, setRatingOverall] = React.useState(null);
    const { register, control, handleSubmit, setValue, errors, getValues, watch } = useForm({
        mode: 'onBlur',
        validationSchema: yup.object({
            // ratingOverall: yup.number(),
            text: yup.string(),
            message: yup.string()
        }),
        defaultValues: {
            reviewType: "instructor",
            ratingOverall: 0,
            text: "",
            message: ""
        }
    });

    const onSubmit = (data) => {

        console.log(data)

        if (!data.ratingOverall) {
            window.alert("Please select a rating")
            return
        }

        setIsLoading(true)

        if (data.ratingOverall > 3) {
            data.message = ""
        } else {
            data.text = ""
        }

        const reviewData = {
            ...data,
            partnerId: selectedInstructor.id
        }


        console.log("review data: ", reviewData)
        apiRequest("reviews/submitReview", "POST", reviewData)
            .then(response => {

                setIsLoading(false)
                setWrittenReview(response)
                analytics.track("Write Review", {
                    ratingOverall: response?.ratingOverall
                })
            })
            .catch(err => {
                window.alert(err)
                setIsLoading(false)
            })
    }

    const textForRating = (rating) => {
        switch (rating) {
        case 0:
            return ""
        case 1:
            return "Not for me"
        case 2:
            return "Not my favorite"
        case 3:
            return "Just okay"
        case 4:
            return "Pretty great"
        case 5:
            return "Best class ever!"
        }
    }

    useEffect(() => {
        register({ name: 'ratingOverall'})
    }, [register])

    // const { ratingOverall } = watch;

    return (
    <div className="container">
        <Helmet>
            <title>{"Write Review"}</title>
        </Helmet>

        <div class="row justify-content-md-center">
            {writtenReview ? (
                <div className="d-flex flex-column align-items-center m-auto">
                    <div class="col-md-auto mb-3">
                        <div className={imageUrl ? "" : "d-none"} style={{height: '120px', width: '120px', margin: 'auto'}}>
                            <Image src={imageUrl} roundedCircle style={{objectFit: 'cover', objectPosition: 'center', width: '100%', height: '100%'}} />
                        </div>
                    </div>
                    <h3 className="mb-3">Thank you!</h3>

                    <ShareButton 
                        className="mb-4"
                        buttonText={`Share ${viewModel.partnerName} with friends!`}
                        link={viewModel.shareLink}
                    />
                    <div className="mb-4">

                        <StarRatings
                            starDimension="24px"
                            starSpacing="4px"
                            starRatedColor="#ffc107"
                            starHoverColor="#ffc107"
                            rating={writtenReview.ratingOverall ?? 0}
                            numberOfStars={5}
                        />
                    </div>
                    <h6 className="text-center" style={{maxWidth: "400px"}}>{writtenReview.text}</h6>
                </div>
            ) : (<>

                <div class="col-md-auto text-center" style={{minWidth: "300px", maxWidth: "450px"}}>
                    <div className="d-flex flex-column">

                        <div className={imageUrl ? "m-auto mb-3" : "d-none m-auto mb-3"} style={{height: '120px', width: '120px', margin: 'auto'}}>
                            <Image src={imageUrl} roundedCircle style={{objectFit: 'cover', objectPosition: 'center', width: '100%', height: '100%'}} />
                        </div>
                        <div clas>
                            <h4>How was it?</h4>
                            {/* <p>{viewModel.twoMinutes}</p> */}
                        </div>

                    </div>
                    
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="d-flex flex-column">
                            <div className="mr-3 mr-3 m-auto">
                                <StarRatings
                                    name="ratingOverall"
                                    starDimension="24px"
                                    starSpacing="4px"
                                    rating={ratingOverall ?? 0}
                                    // rating={ratingOverall}
                                    starRatedColor="#ffc107"
                                    starHoverColor="#ffc107"
                                    numberOfStars={5}
                                    // ref={register}
                                    changeRating={(val) => {
                                        console.log(val)
                                        setRatingOverall(val)
                                        setValue('ratingOverall', val)
                                    }}
                                />
                            </div>

                            <h6 className="m-0 mt-2">{textForRating(ratingOverall)}</h6>
                        </div>
                        <br></br>
                        <div>
                            <div className={(ratingOverall > 3 || ratingOverall === null) ? "" : "d-none"}>
                                <h5>Leave me a testimonial</h5>
                                <textarea reg rows="10" name="text" ref={register} placeholder={"That class was..."} type="text" className="form-control" aria-label="Full name"/>
                            </div>
                            <div className={(ratingOverall <= 3 && ratingOverall >= 1) ? "" : "d-none"}>
                                <h5>Write feedback to send me directly</h5>
                                <textarea rows="10" name="message" ref={register} placeholder={"Here's what I thought"} type="text" className="form-control" aria-label="Full name"/>
                            </div>
                        </div>
                        

                        <br></br>
                        <button disabled={isLoading} type="submit" className="w-100 btn btn-primary primaryColor">
                            Submit
                            {/* <Spinner
                            animation="border"
                            size="sm"
                            role="status" 
                            className={(isLoading ? "ml" : "d-none") + " ml-2"}/> */}
                        </button>
                    </form>
                </div>
            
            </>)}
            </div>
        <DevTool control={control} />
    </div>
    );
}

export default WriteReview;
